export default "__VITE_ASSET__DP$jkYz6__"